import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-persona',
    templateUrl: './block-persona.component.html',
})

export class BlockPersonaComponent extends BlockAbstractComponent implements OnInit {

}
